import { SET_DICTIONARY_FILTERS } from "src/app/components/DictionaryFilters/redux/dictionaryFiltersTypes";

export default function resetDictionaryFilters() {
  return {
    type: SET_DICTIONARY_FILTERS,
    payload: { filters: [] },
  };
}
